import {
  FaCheck,
  FaPause,
  FaTimes,
  FaBox,
  FaFileInvoiceDollar,
  FaClock,
  FaShareSquare,
  FaCheckCircle,
  FaPlay,
} from 'react-icons/fa';

interface Props {
  value: string;
  className?: string;
  days?: number;
}

interface StatusConfig {
  bgClass: string;
  icon: React.ReactNode;
}

/**
 * 🔥 Configuración centralizada de estados
 */
const statusConfigMap: Record<string, StatusConfig> = {
  /**
   * ===========================
   * 🔄 FLUJO INTERNO
   * ===========================
   */
  FINALIZED: {
    bgClass: 'bg-[#3CA745]',
    icon: <FaCheck />,
  },

  PROCESS: {
    bgClass: 'bg-[#3CA745]',
    icon: <FaPlay />,
  },

  PENDING: {
    bgClass: 'bg-[#F9C107]',
    icon: <FaPause />,
  },

  REJECTED: {
    bgClass: 'bg-[#DC3545]',
    icon: <FaTimes />,
  },

  CANCELED: {
    bgClass: 'bg-[#DC3545]',
    icon: <FaTimes />,
  },

  SETTLED: {
    bgClass: 'bg-primary',
    icon: <FaBox />,
  },

  CREDITED: {
    bgClass: 'bg-[#0D6EFD]',
    icon: <FaFileInvoiceDollar />,
  },

  /**
   * ===========================
   * 🧾 ESTADOS DTE
   * ===========================
   */
  DTE_PENDING: {
    bgClass: 'bg-[#FF8C00]',
    icon: <FaClock />,
  },

  DTE_SENT: {
    bgClass: 'bg-[#0D6EFD]',
    icon: <FaShareSquare />,
  },

  DTE_PROCESSED: {
    bgClass: 'bg-[#3CA745]',
    icon: <FaCheckCircle />,
  },

  DTE_REJECTED: {
    bgClass: 'bg-[#DC3545]',
    icon: <FaTimes />,
  },

  DRAFT_CANCELLED: {
    bgClass: 'bg-[#637381]',
    icon: <FaTimes />,
  },

  /**
   * ===========================
   * 💰 RECEIVABLES
   * ===========================
   */
  PAID: {
    bgClass: 'bg-[#3CA745]',
    icon: <FaCheckCircle />,
  },

  PARTIAL: {
    bgClass: 'bg-[#3BA2B8]',
    icon: <FaPause />,
  },

  OVERDUE: {
    bgClass: 'bg-[#DC3545]',
    icon: <FaTimes />,
  },
};

const StatusActionIcon: React.FC<Props> = ({ value, className = '' }) => {
  const config = statusConfigMap[value];

  if (!config) return null;

  return (
    <span
      className={`
        flex
        h-5
        w-5
        items-center
        justify-center
        rounded-lg
        text-xs
        text-white
        shadow-sm
        ${config.bgClass}
        ${className}
      `}
    >
      {config.icon}
    </span>
  );
};

export default StatusActionIcon;
